import React from "react";

import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import DemographyData from "@app/component/DemographicData/DemographyData";
import LoadingDots from "@app/component/LoadingDots";
import { Interactive } from "@app/component/map/FeaturedMap";
import DemographicData from "@app/scene/map/types/DemographicData";

import styles from "./Loader.module.scss";

interface Props {
  loading?: boolean;
  regionDemographyData?: Omit<DemographicData, "code" | "type">;
  regionsSelected?: number;
}

const Loader: React.FC<Props> = ({ loading, regionDemographyData, regionsSelected }) => {
  const intl = useIntl();

  if (regionsSelected === undefined) {
    return null;
  }

  return (
    <Interactive>
      <Tooltip
        align={{ offset: [60, 20] }}
        className={styles.tooltip}
        title={!loading && regionDemographyData && <DemographyData data={regionDemographyData} />}
      >
        <div className={styles.container}>
          <div className={styles.content}>
            {loading ? (
              <LoadingDots />
            ) : (
              intl.formatMessage(
                {
                  id: "map.territories.loader",
                  defaultMessage:
                    "{count, plural, =0 {No areas selected} one {{count} area selected} other {{count} areas selected}}",
                  description: "Number of selected areas when creating/editing a territory",
                },
                { count: regionsSelected }
              )
            )}
          </div>
        </div>
      </Tooltip>
    </Interactive>
  );
};

export default Loader;
